import cx from "classnames"
import React, { useState } from "react"

import * as styles from "./styles.module.scss"
import InputText, { InputTextSize } from "../InputText"
import {
  FlowInputCallback,
  FlowInputCallbackArgs,
  FlowInputTextType,
} from "types"

export interface EmailDialogProps {
  description: string
  onSubmit: FlowInputCallback
  show: boolean
  title: string
}

const EmailDialog: React.FC<EmailDialogProps> = ({
  description,
  onSubmit,
  show,
  title,
}) => {
  const [inputError, setInputError] = useState<string>("")
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [triggeredDialog, setTriggeredDialog] = useState<boolean>(false)

  const closeDialog = () => {
    setIsOpen(false)
    removeScrollLock()
  }

  const removeScrollLock = () => {
    document.body.classList.remove("bet-StaticPage--noScroll")
    document.documentElement.classList.remove("bet-StaticDocument--noScroll")
  }

  const addScrollLock = () => {
    document.body.classList.add("bet-StaticPage--noScroll")
    document.documentElement.classList.add("bet-StaticDocument--noScroll")
  }

  const reachedEndScreen = () => {
    setTriggeredDialog(true)
    addScrollLock()
  }

  const onSubmitFormat = ({ flowKey, value }: FlowInputCallbackArgs) => {
    // TODO: Why are we allowing user@[IP Address] emails?
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (!value.match(emailRegex)) {
      setInputError("Invalid email")
    } else {
      setInputError("")
      onSubmit({
        flowKey,
        value,
        display: value as string,
      })
      closeDialog()
    }
  }

  // TODO: Trigger on event (e.g., Next button on last question) so logic not called on every render
  if (show && !triggeredDialog) {
    reachedEndScreen()
  }

  return (
    <dialog
      className={cx({
        [styles.emailDialog]: true,
        [styles.isOpen]: show && isOpen,
      })}
      data-qa="question-email"
      id="email"
    >
      <div className={styles.background}></div>
      <div className={styles.pagePadding}>
        <div className={styles.box}>
          <div className={styles.header}>
            <h2 className={styles.heading}>{title}</h2>
            <p className={styles.subhead}>{description}</p>
          </div>
          <div className={styles.input}>
            <InputText
              onSubmit={onSubmitFormat}
              inputType={FlowInputTextType.Email}
              size={InputTextSize.Medium}
              pattern={
                "^[_a-zA-Z0-9][a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
              }
              placeholder={"your email"}
              disabled={!show}
              flowKey="email"
            />
          </div>
          <div className={styles.error}>{inputError}</div>
        </div>
      </div>
    </dialog>
  )
}

export default EmailDialog
